// src/components/molecules/FilterPresetChip/FilterPresetChip.jsx
import React from 'react';
import PropTypes from 'prop-types';
import { Chip, useTheme } from '@mui/material';
import { operationalRadii } from '../../../design-system/tokens';

const FilterPresetChip = ({
  label,
  active = false,
  activeColor = 'primary',
  hoverColor,
  onClick,
  className = '',
  sx,
  ...props
}) => {
  const theme = useTheme();
  const resolvedHoverColor = hoverColor || theme.palette[activeColor]?.main || theme.palette.primary.main;

  return (
    <Chip
      label={label}
      size="small"
      variant={active ? 'filled' : 'outlined'}
      color={active ? activeColor : 'default'}
      className={`filter-preset-chip ${className}`}
      onClick={onClick}
      sx={{
        cursor: 'pointer',
        borderRadius: `${operationalRadii.control}px`,
        '&:hover': {
          borderColor: resolvedHoverColor
        },
        ...sx
      }}
      {...props}
    />
  );
};

FilterPresetChip.propTypes = {
  label: PropTypes.string.isRequired,
  active: PropTypes.bool,
  activeColor: PropTypes.oneOf([
    'default',
    'primary',
    'secondary',
    'error',
    'info',
    'success',
    'warning'
  ]),
  hoverColor: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string,
  sx: PropTypes.object
};

export default FilterPresetChip;
